module.exports = __webpack_public_path__ + "static/media/background.a417042b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background.svg
// module id = 599
// module chunks = 0